import React, { useEffect, useState, useCallback } from 'react';

import { connect } from 'react-redux';
import { toast } from "react-toastify"

// jwtService
import jwtService from 'jwtService';

// custom hooks
import useUserActivity from 'hooks/useUserActivity';
import useCrossTabLogout from 'hooks/useCrossTabLogout';
import { triggerCrossTabLogout } from 'hooks/useCrossTabLogout/triggerCrossTabLogout';


export const SessionSupport = (props) => {
	const isAdLogin = localStorage.getItem('isAdLogin') || '';
	const isSsoLogin = localStorage.getItem('isSsoLogin') || '';

	// console.log("In SessionSupport component === appConfiguration", props.appConfiguration)

	const getIdleMinutes = (envValue, fallbackMinutes) => {
		const parsedMinutes = Number(envValue);
		return Number.isFinite(parsedMinutes) && parsedMinutes > 0 ? parsedMinutes : fallbackMinutes;
	};
	const adInactivityMins = getIdleMinutes(process.env.REACT_APP_AD_IDLE_TIMEOUT_MINUTES, props.appConfiguration?.adIdleTimeoutMinutes || 60);
	const defaultInactivityMins = getIdleMinutes(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES, props.appConfiguration?.idleTimeoutMinutes || 10);
	const inactivityThresholdMs = isAdLogin === 'true' ? adInactivityMins * 60 * 1000 : defaultInactivityMins * 60 * 1000;

	// console.log("In SessionSupport component === adInactivityMins", adInactivityMins)
	// console.log("In SessionSupport component === defaultInactivityMins", defaultInactivityMins)
	// console.log("In SessionSupport component === inactivityThresholdMs", inactivityThresholdMs)

	const handleInactivity = useCallback(() => {
		const isAdLogin = localStorage.getItem('isAdLogin') || '';
		const isSsoLogin = localStorage.getItem('isSsoLogin') || '';
		let ssoConfig = null;
		let userEmailReport = localStorage.getItem('userEmailReport')
		if (userEmailReport) {
			let emailCheckData = JSON.parse(window.atob(userEmailReport))
			ssoConfig = emailCheckData?.ssoConfig
		}
		console.log("isSsoLogin , isAdLogin", isAdLogin !== 'true' && isSsoLogin !== 'true', isAdLogin, isSsoLogin)
		// For AD/MFA users, enforce idle logout after 1 hour.
		if (isAdLogin === 'true') {
			toast.info('Session expired due to inactivity.', { toastId: 'logout-session' })
			triggerCrossTabLogout();
			const jwt_access_token = localStorage.getItem('jwt_access_token')
			if (jwt_access_token) {
				jwtService.logout()
			}
			return;
		}
		// Don't call refresh token in both scenarios
		if (isAdLogin !== 'true' && (isSsoLogin !== 'true' || (isSsoLogin == 'true' && ssoConfig?.system === 'pingID'))) {
			toast.info('Session expired due to inactivity.', { toastId: 'logout-session' })
			// TODO: Clear session data, redirect to login, etc.
			triggerCrossTabLogout(); // Notify other tabs
			const jwt_access_token = localStorage.getItem('jwt_access_token')
			if (jwt_access_token)
				jwtService.logout()
		}
	}, []);

	const handleCrossTabLogout = useCallback(() => {
		// Same logout logic (without sending the message again to avoid loops)
		const jwt_access_token = localStorage.getItem('jwt_access_token')
		if (jwt_access_token)
			jwtService.logout()
	}, []);

	// ✅ Always call hooks unconditionally (React Rules of Hooks requirement)
	// The hooks themselves handle the conditional logic internally via refs
	const lastActivity = useUserActivity(handleInactivity, inactivityThresholdMs);
	useCrossTabLogout(handleCrossTabLogout);

	return <React.Fragment></React.Fragment>
};

const mapDispatchToProps = {
};

const mapStateToProps = state => {
	return {
		appConfiguration: state.form.document?.appConfig,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionSupport);
